module.exports = __webpack_public_path__ + "img/icon-audacieux-normands-red.8e15af5a.svg";